import * as React from 'react';
import { useContext } from 'react';
import PerPersonPriceOverview from '../../../components/PerPersonPriceOverview/PerPersonPriceOverview';
import ScrollToBtn from '../../../components/ScrollToBtn/ScrollToBtn';
import { ReactReduxContext } from 'react-redux';
import { __ } from '../../../helpers/TranslationService';
import { overviewPriceHelper } from '../../../components/PriceTable/overviewPriceHelper';
import styled from '@emotion/styled';

interface ICruiseStageTabHeader {
    title?: string;
    descr?: string;
    isPriceBtnVisible?: boolean;
}

const ScrollToButtonStyled = styled(ScrollToBtn)`
    margin-top: 12px;
`;

const CruiseStageTabHeader = (props: ICruiseStageTabHeader): JSX.Element => {
    const { title, descr, isPriceBtnVisible = false } = props;
    if (!title && !descr && !isPriceBtnVisible) return null;

    const { store } = useContext(ReactReduxContext);
    const { cruisePage, pageData } = store.getState();

    const compName = 'cruise-stage-tab-header';
    return (
        <section className={`${compName} col-xs-12 noPadding`}>
            <header className={`${compName}__header`}>
                {title?.length > 0 && <strong className={`${compName}__title`}>{title}</strong>}
                {descr?.length > 0 && (
                    <strong className={`${compName}__descr`}>
                        <i>{descr}</i>
                    </strong>
                )}
            </header>
            {isPriceBtnVisible && (
                <div className={`${compName}__price-button`}>
                    <PerPersonPriceOverview {...overviewPriceHelper(pageData, cruisePage)} />
                    <ScrollToButtonStyled
                        title={__('Dates and Prices', 'dreamlines')}
                        anchorSelector=".requestFormContainer"
                        disabled={cruisePage.sails.length === 0}
                    />
                </div>
            )}
        </section>
    );
};

export default CruiseStageTabHeader;
